export default "  <button (click)=\"addToShoppingCartOneByOne()\" color=\"primary\">\r\n        ADD TO CART\r\n      </button>";